import React from 'react';
import { CTable, CTableRow, CTableDataCell, CTableHead, CTableHeaderCell, CTableBody } from '@coreui/react';

const ListSkeleton = () => {
    return (
        <CTable align="middle" className="mb-0 modern-table">
            <CTableHead className='sticky-header'>
                <CTableRow>
                    <CTableHeaderCell className='text-center'>ID</CTableHeaderCell>
                    <CTableHeaderCell>Proyecto</CTableHeaderCell>
                    <CTableHeaderCell>Creación</CTableHeaderCell>
                    <CTableHeaderCell>Estado</CTableHeaderCell>
                    <CTableHeaderCell>Periodo</CTableHeaderCell>
                    <CTableHeaderCell className="text-center">Cant.</CTableHeaderCell>
                    <CTableHeaderCell></CTableHeaderCell>
                </CTableRow>
            </CTableHead>
            <CTableBody>
                {Array.from({ length: 10 }).map((_, i) => (
                    <CTableRow key={i} className="stagger-in" style={{ animationDelay: `${i * 40}ms` }}>
                        <CTableDataCell className="text-center">
                            <div className="skeleton-item" style={{ width: '30px' }}></div>
                        </CTableDataCell>
                        <CTableDataCell>
                            <div className="d-flex align-items-center">
                                <div className="skeleton-item me-2" style={{ width: '8px', height: '8px', borderRadius: '50%' }}></div>
                                <div className="skeleton-item" style={{ width: '150px' }}></div>
                            </div>
                        </CTableDataCell>
                        <CTableDataCell>
                            <div className="skeleton-item" style={{ width: '80px' }}></div>
                        </CTableDataCell>
                        <CTableDataCell>
                            <div className="skeleton-item" style={{ width: '70px', height: '20px', borderRadius: '12px' }}></div>
                        </CTableDataCell>
                        <CTableDataCell>
                            <div className="skeleton-item mb-1" style={{ width: '60px', height: '14px' }}></div>
                            <div className="skeleton-item" style={{ width: '100px', height: '12px' }}></div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                            <div className="skeleton-item" style={{ width: '40px' }}></div>
                        </CTableDataCell>
                        <CTableDataCell>
                            <div className="skeleton-item" style={{ width: '32px', height: '32px', borderRadius: '4px' }}></div>
                        </CTableDataCell>
                    </CTableRow>
                ))}
            </CTableBody>
        </CTable>
    );
};

export default ListSkeleton;
